<template>
  <div class="content">
    <div class="card-box">
      <div class="header">
        <span class="title">查询条件</span>
      </div>
      <div class="inp-list">
        <div class="item item-2">
          <span class="label">开奖时间</span>
          <el-date-picker
                class="inp"
                v-model="formData.valTime"
                size="small"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :shortcuts="render.shortcuts"
              >
              </el-date-picker>
        </div>
        <div class="item">
          <span class="label">类型</span>
          <el-select class="inp" size="small" v-model="formData.valType" placeholder="请选择">
              <el-option
                v-for="item in render.typeChoose"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </div>
        <div class="item">
          <span class="label">昵称或用户id</span>
          <el-input class="inp" size="small" v-model="formData.valNickname" placeholder="请输入昵称或用户id"></el-input>
        </div>
        <div class="item">
          <span class="label">单号</span>
          <el-input class="inp" size="small" v-model="formData.valOrderSn" placeholder="请输入单号"></el-input>
        </div>

      </div>
      <div class="btn-ct">
        <el-button @click="func.search" class="search" type="primary" size="small">查询</el-button>
      </div>
    </div>
    <div class="card-box data-table">
      <div class="header">
        <span class="title">共{{formData.total}}条，每页{{formData.pageSize}}条</span>
        <div class="header-icons">
          <!-- <i @click="func.loadData()" class="el-icon-download header-icon"></i> -->
          <!-- <i @click="func.refresh()" class="el-icon-refresh header-icon"></i> -->
        </div>
      </div>
      <el-table
            :data="formData.tableData"
            stripe
            style="width: 100%">
            <el-table-column
              prop="Id"
              label="ID"
              width="100">
            </el-table-column>
            <el-table-column
              prop="OrderSn"
              width="200"
              label="单号">
            </el-table-column>
            <el-table-column
              prop="UserId"
              width="140"
              label="用户id">
            </el-table-column>
            <el-table-column
              prop="Nickname"
              width="140"
              label="用户名">
            </el-table-column>
            <el-table-column
              width="140"
              label="金额">
              <template #default="scope">
                <div :class="scope.row.Money>0?'color-2':'color-3'">{{scope.row.Money}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="Balance"
              width="140"
              label="当前余额">
            </el-table-column>
            <el-table-column
              prop="TypeStr"
              width="140"
              label="类型">
            </el-table-column>
            <el-table-column
              prop="CreatedAtStr"
              min-width="200"
              label="时间">
            </el-table-column>
          </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="func.pageChange"
        :page-size="formData.pageSize"
        :current-page="formData.curPage"
        :total="formData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { shortcuts } from '@/data/default'
import { lots } from '@/data/lot'
import { getType,typeChoose } from '@/data/moneyLogType'
import { toDay } from "@/common/func"
export default {
  name: 'MemberMoney',
  setup () {
    const tableData = []
    const render = {
      shortcuts,
      typeChoose,
    }
    const formData = reactive({
      tableData,
      curData: {},
      valTime: '',
      valOrderSn:'',
      valNickname:'',
      valType:-1,
      // pagination
      curPage: 1,
      pageSize: 10,
      lots,
      total: 1
    })
    const func = {
      search () {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange (val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh(){
        formData.valTime = '',
        func.loadData(1)
      },
      async loadData(page=1){
        try{
          formData.tableData = []
          formData.curPage = page
          let params = {
              page,
          }
          if(formData.valOrderSn){
            params.orderSn = formData.valOrderSn
          }
          if(formData.valType != -1){
            params.type = formData.valType
          }
          if(formData.valNickname){
            let id = parseInt(formData.valNickname)
            if(isNaN(id)){
              params.nickname = formData.valNickname
            }else{
              params.userId = formData.valNickname
            }
          }
          if(formData.valTime){
            params.startAt = Math.floor(formData.valTime[0].getTime()/1000)
            params.endAt = Math.floor(formData.valTime[1].getTime()/1000)
          }
          let res = await axios.get(`/admin/balance`,{
            params
          })
          formData.total = res.Total
          res.List.map((item)=>{
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.TypeStr = getType(item.Type)
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        }catch(e){
          console.log("loadData",e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      func.loadData()
    })
    return {
      func,
      render,
      formData
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  box-sizing: border-box;
  padding: 1.25rem;
  margin-bottom: 6.25rem;
  .color-0{
    color: $color-warning;
    font-weight: bold;
  }
  .color-1{
    color: $color-info;
    font-weight: bold;
  }
  .color-2{
    color: $color-success;
    font-weight: bold;
  }
  .color-3{
    color: $color-error;
    font-weight: bold;
  }
  .avatar{
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
  }
  .inp-block{
    display: block;
  }
  >.card-box{
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;
    .header{
      text-align:left;
      margin-bottom: 1.25rem;
      position: relative;
      >.title{
        font-size:2rem;
        font-weight: 500;
      }
      >.header-icons{
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;
        .header-icon{
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color:#969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }
    >.btn-ct{
      text-align: right;
      :deep(.el-button--small){
        padding: 0.625rem 2rem;
      }
    }
    .inp-list{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      >.item{
        width: 32%;
        display: flex;
        align-items: center;
        margin-bottom: 1.25rem;
        &.item-2{
          width: 99%;
        }
        &.item-3{
          width: 64%;
        }
        .label{
          margin-right: 0.625rem;
          width: 14rem;
          font-size: 1.8rem;

        }
        :deep(.el-range-editor--small.el-input__inner){
          flex: 1;
        }
        .inp{
          flex: 1;
        }
      }
    }
  }
  >.el-alert-my{
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;
    .el-alert-my-txt{
      font-size: 0.875rem;
      >.tips{
        font-weight: bold;
      }
    }
    :deep(.el-alert__closebtn){
      top: 1.25rem;
      font-size: 1rem;
    }
  }
  >.data-table{
    :deep(.el-table){
      .cell{
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-table__row{
        cursor: pointer;
      }
    }
  }
  >.pagination{
    text-align: right;
    margin-top: 1.25rem;
  }
  .el-form-row{
    display:flex;
    justify-content: space-between;
    :deep(.el-form-item){
      width: 49%;
    }
  }
  .el-select-my{
    text-align: left;
    display: block;
  }
}
</style>
